import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-bucket-icon',
  templateUrl: './design-bucket.component.html'
})
export class DesignBucketComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
